import { useContext } from "preact/hooks";
import { VolumeStoreContext } from "store/Volume";

export const useVolumeStore = () => useContext(VolumeStoreContext);
